import { useRef } from 'react';
import { useOption } from 'react-aria';
import type { Node } from '@react-types/shared';
import type { ListState } from 'react-stately';
import s from './ListBoxOption.module.scss';
import { joinClassNames } from '../../shared/formFieldUi';

/* For detailed prop types see react-aria */
interface ListBoxOptionProps<T> {
  item: Node<T>;
  state: ListState<T>;
}

/** Listbox option based on react-aria — https://react-spectrum.adobe.com/react-aria/useComboBox.html */
function ListBoxOption<T>({ item, state }: ListBoxOptionProps<T>) {
  const ref = useRef<HTMLLIElement>(null);
  const { optionProps, isSelected, isFocused } = useOption(
    { key: item.key },
    state,
    ref
  );

  const className = joinClassNames(
    s.listBoxOption,
    isSelected && s.isSelected,
    !isSelected && isFocused && s.isFocused
  );

  return (
    <li
      /* oxlint-disable-next-line react/jsx-props-no-spreading */
      {...optionProps}
      ref={ref}
      className={className}
    >
      <div>{item.rendered}</div>
    </li>
  );
}

export default ListBoxOption;
